<template lang="html">
  <v-page class="client contract">

    <v-topbar :profile="profile"/>
    <v-breadcrumb v-if="profile === 'client'" :steps="[
      {label:'Profissionais', to: {name:'client-vibbrants'}},
      {label:contract.vibbrante.name},
      {label:'Contrato'}
    ]"/>
    <v-breadcrumb v-else :steps="[
      {label:'Clientes', to: {name:'vibbrant-clients'}},
      {label:contract.client.name},
      {label:'Contrato'}
    ]"/>


    <v-container class="mt-5">
      <v-card>
        <v-inner>
          <template v-if="profile === 'client'">
            <span v-html="client_contract_head_model.template"></span>
            <span v-html="client_contract_body_model.template"></span>


            <p>Por estarem assim justas e contratadas, as partes declaram aceitar expressamente as cláusulas supra e firmam o presente instrumento.
            </p>
            <v-divider line/>
            <v-text tag="h5"><b>ANEXO I:</b></v-text>
            <p><b>PERFIL PROFISSIONAL CONTRATADO:</b> {{contract.vibbrante.profile + ' ' + contract.vibbrante.focus}}.</p>
            <p><b>QUANTIDADE DE HORAS CONTRATADAS:</b> {{contract.expect_hours}} horas.</p>
            <p><b>VALOR DA HORA CONTRATADO:</b>: {{contract.hour_value | currency}} </p>
            <p><b>DISPONIBILIDADE PARA INÍCIO DOS TRABALHOS:</b> {{ contract.expected_start_date | moment('DD/MM/YYYY')}}</p>
          </template>
          <template v-if="profile === 'vibbrant'">
            <span v-html="vibbrante_contract_head_model.template"></span>

            <span v-html="vibbrante_contract_body_model.template"></span>
            <p>Por estarem assim justas e contratadas, as partes declaram aceitar expressamente as cláusulas supra e firmam o presente instrumento.
            </p>
            <v-divider line/>
            <v-text tag="h5"><b>ANEXO I:</b></v-text>
            <p><b>PERFIL PROFISSIONAL CONTRATADO:</b> {{contract.vibbrante.profile + ' ' + contract.vibbrante.focus}}.</p>
            <p><b>QUANTIDADE DE HORAS CONTRATADAS:</b> {{contract.expect_hours}} horas.</p>
            <p><b>VALOR DA HORA CONTRATADO:</b></p>
            <v-row :size="2">
              <v-col :xs="12" :sm="12" :md="6" :lg="2">
                <v-input type="money" v-model="contract.expected_hour_value_vibbrante" disabled>Valor/hora padrão</v-input>
              </v-col>
              <v-col :xs="12" :sm="12" :md="6" :lg="3">
                <v-input type="money" :min="0" :max="hour_val" disabled v-model="contract.hour_value_vibbrante" helptext="Preencher somente se deseja aplicar um valor promocional para esse contrato">Valor/hora promocional</v-input>
              </v-col>
            </v-row>
            <p><b>DATA DE INÍCIO DOS TRABALHOS:</b></p>
            <v-row :size="2">
              <v-col :xs="12" :sm="12" :md="6" :lg="4">
                <v-input disabled :value="getStartDate" type="date" helptext="Para o caso de não haver disponibilidade para início imediato do Vibbrante">Data início prevista</v-input>
              </v-col>
            </v-row>
          </template>
          <v-divider line/>
          <p v-if="profile === 'vibbrant'">
            <b>Contrato assinado em Florianópolis/SC em {{ contract.signed_date_vibbrante | moment('DD') }} de {{ contract.signed_date_vibbrante | moment('MMMM') }} de {{ contract.signed_date_vibbrante | moment('YYYY') }}.</b>
          </p>
          <p v-else>
            <b>Contrato assinado em Florianópolis/SC em {{ contract.signed_date_client | moment('DD') }} de {{ contract.signed_date_client | moment('MMMM') }} de {{ contract.signed_date_client | moment('YYYY') }}.</b>
          </p>
          <div v-if="contract.contract_additives.length > 0">
            <v-divider line/>
            <v-text tag="h5"><b>ADITIVOS:</b></v-text>
            <v-text v-for="additive in contract.contract_additives" :key="additive.id">{{additive.hours}} hora(s) adicionada(s) em {{additive.created_at | moment('DD/MM/YYYY') }}.</v-text>
          </div>
        </v-text>

        </v-inner>
      </v-card>
    </v-container>
  </v-page>
</template>

<script>
import Contract from '../modules/contract'
import apiClient from '@/api/client'
import apiVibbrante from '@/api/vibbrante'
import * as moment from 'moment'

export default {
  props: {
    profile: String,
    start_date: String,
    vibbrante_contract_body_model: {},
    vibbrante_contract_head_model: {},
    client_contract_body_model: {},
    client_contract_head_model: {}
  },
  components: {
    'v-contract': Contract
  },
  data() {
    return {
      contract: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      if (this.profile === 'vibbrant') {
        apiVibbrante.vibbranteGetContract(this.$route.params.id).then((response) => {
          if (response.status === 200) {
            this.contract = response.data
            this.$store.dispatch('loadVibbranteCurrentContract', response.data)
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
        apiVibbrante
          .vibbranteGetSignedContract(this.$route.params.id)
          .then((response) => {
            if (response.status === 200) {
              response.data.forEach((element) => {
                if (element.apply_to.includes('vibbrante_head') || element.apply_to.includes('freelancer_head')) {
                  this.vibbrante_contract_head_model = element
                }
                if (element.apply_to.includes('vibbrante_body') || element.apply_to.includes('freelancer_body')) {
                  this.vibbrante_contract_body_model = element
                }
              })
            }
          })
      } else {
        apiClient.clientGetContract(this.$route.params.id).then((response) => {
          if (response.status === 200) {
            this.contract = response.data
            this.$store.dispatch('loadClientCurrentContract', response.data)
          }
        }).catch((e) => {
          this.$notify(e, 'error')
        })
        apiClient
          .clientGetSignedContract(this.$route.params.id)
          .then((response) => {
            if (response.status === 200) {
              response.data.forEach((element) => {
                if (element.apply_to.includes('client_head')) {
                  this.client_contract_head_model = element
                }
                if (element.apply_to.includes('client_body')) {
                  this.client_contract_body_model = element
                }
              })
            }
          })
      }
    }
  },
  computed: {
    getStartDate() {
      return moment(this.contract.expected_start_date).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/parts/pages/contract.vue